import { render } from "./ParticipantsBreakdown.vue?vue&type=template&id=faedbf8c"
import script from "./ParticipantsBreakdown.vue?vue&type=script&lang=js"
export * from "./ParticipantsBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__